import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_CHARGER_LOG = createActionTypes('FETCH_CHARGER_LOG');
export const DELETE_CHARGER_LOG = createActionTypes('DELETE_CHARGER_LOG');
export const DOWNLOAD_CHARGER_LOG_DATA = createActionTypes('DOWNLOAD_CHARGER_LOG_DATA');
export const DOWNLOAD_TABULAR_METERVALUE = createActionTypes('DOWNLOAD_TABULAR_METERVALUE');
export const FETCH_USER_ACTIVITY = createActionTypes('FETCH_USER_ACTIVITY');
